import { Heading, Stack } from '@chakra-ui/react';
import { useSelector } from "react-redux";
import { SalesInvoicesChart } from './Charts';
import { BarChart, CartesianGrid, ResponsiveContainer, XAxis, YAxis, Bar, AreaChart, Area, Tooltip } from 'recharts';
import { HiDocument, HiDocumentReport } from 'react-icons/hi';
import { RiDraftFill } from 'react-icons/ri';
import { useEffect,useState } from 'react';
import { GET } from '../../utils/ApiRequestProvider';

export interface InvoiceData {
    pending: number;
    processing: number;
    processed: number;
    approved: number;
}


const initialSalesInvoiceData: InvoiceData = {
    pending : 0,
    processing : 0,
    processed : 0,
    approved : 0
}

export function Dashboard() {
        const [salesInvoiceData,setSalesInvoiceData] = useState<InvoiceData>(initialSalesInvoiceData);
    const [purchaseInvoiceData,setPurchaseInvoiceData] = useState<InvoiceData>(initialSalesInvoiceData);
    const [OtherDocumentsData,setOtherDocumentsData] = useState<InvoiceData>(initialSalesInvoiceData);
    const business = useSelector((state: any) => state.selections.value?.business);
    const data = [
        {
            "name": "Jan 2022",
            "expenses": 4000
        },
        {
            "name": "Feb 2022",
            "expenses": 8000
        },
        {
            "name": "Mar 2022",
            "expenses": 5000
        },
        {
            "name": "Apr 2022",
            "expenses": 15000
        },
        {
            "name": "May 2022",
            "expenses": 7000
        },
        {
            "name": "Jun 2022",
            "expenses": 1000
        },
        {
            "name": "Jul 2022",
            "expenses": 19000
        },
        {
            "name": "Aug 2022",
            "expenses": 10000
        },
        {
            "name": "Sep 2022",
            "expenses": 15000
        },
        {
            "name": "Oct 2022",
            "expenses": 3500
        },
        {
            "name": "Nov 2022",
            "expenses": 3700
        },
        {
            "name": "Dec 2022",
            "expenses": 9000
        },
    ]

    const data2 = [
        {
            "name": "Jan 2022",
            "sales": 4000,
            "expenses": 2400
        },
        {
            "name": "Feb 2022",
            "sales": 12000,
            "expenses": 8000
        },
        {
            "name": "Mar 2022",
            "sales": 6000,
            "expenses": 5000
        },
        {
            "name": "Apr 2022",
            "sales": 50000,
            "expenses": 15000
        },
        {
            "name": "May 2022",
            "sales": 45000,
            "expenses": 7000
        },
        {
            "name": "Jun 2022",
            "sales": 40000,
            "expenses": 1000
        },
        {
            "name": "Jul 2022",
            "sales": 50000,
            "expenses": 40000
        },
        {
            "name": "Aug 2022",
            "sales": 48000,
            "expenses": 32000
        },
        {
            "name": "Sep 2022",
            "sales": 20000,
            "expenses": 50000
        },
        {
            "name": "Oct 2022",
            "sales": 35000,
            "expenses": 45000
        },
        {
            "name": "Nov 2022",
            "sales": 60000,
            "expenses": 30000
        },
        {
            "name": "Dec 2022",
            "sales": 65000,
            "expenses": 45000
        }
    ]

    const fetchSalesInvoiceData = async () => {
        if(business?.id === undefined) {
            setSalesInvoiceData(initialSalesInvoiceData);
            return;
        }
        const response = await GET(`/api/Documents/${business?.id}/SalesInvoice/list?sortColumn=Date&sortOrder=desc`);
        if(response.status === "success"){
            if(response.data.documents.length === 0){
                setSalesInvoiceData(initialSalesInvoiceData);
                return;
            }
            const data_Sales = response.data.documents;
            data_Sales.forEach((data: any) => {
                if(data.status === "Uploaded"){
                    setSalesInvoiceData((prev) => {
                        return {
                            ...prev,
                            pending : prev.pending + 1
                        }
                    });
                }else if(data.status === "Review"){
                    setSalesInvoiceData((prev) => {
                        return {
                            ...prev,
                            processing : prev.processing + 1
                        }
                    });
                }else if(data.status === "Data Entered"){
                    setSalesInvoiceData((prev) => {
                        return {
                            ...prev,
                            processed : prev.processed + 1
                        }
                    });
                }else if(data.status === "Exported"){
                    setSalesInvoiceData((prev) => {
                        return {
                            ...prev,
                            approved : prev.approved + 1
                        }
                    });
                }
            });
        }
    }

    const fetchPurchaseInvoiceData = async () => {
        if(business?.id === undefined) {
            setPurchaseInvoiceData(initialSalesInvoiceData);
            return;
        }

        const response = await GET(`/api/Documents/${business?.id}/PurchaseInvoice/list?sortColumn=Date&sortOrder=desc`);
        if(response.status === "success"){
            if(response.data.documents.length === 0){
                setPurchaseInvoiceData(initialSalesInvoiceData);
                return;
            }
            const data_Purchase = response.data.documents;
            data_Purchase.forEach((data: any) => {
                if(data.status === "Uploaded"){
                    setPurchaseInvoiceData((prev) => {
                        return {
                            ...prev,
                            pending : prev.pending + 1
                        }
                    });
                }else if(data.status === "Review"){
                    setPurchaseInvoiceData((prev) => {
                        return {
                            ...prev,
                            processing : prev.processing + 1
                        }
                    });
                }else if(data.status === "Data Entered"){
                    setPurchaseInvoiceData((prev) => {
                        return {
                            ...prev,
                            processed : prev.processed + 1
                        }
                    });
                }else if(data.status === "Exported"){
                    setPurchaseInvoiceData((prev) => {
                        return {
                            ...prev,
                            approved : prev.approved + 1
                        }
                    });
                }
            });
        }
    }

    const fetchOtherDocumentsData = async () => {
        if(business?.id === undefined) {
            setOtherDocumentsData(initialSalesInvoiceData);
            return;
        }

        const response = await GET(`/api/Documents/${business?.id}/OtherDocuments/list?sortColumn=Date&sortOrder=desc`);
        if(response.status === "success"){
            if(response.data.documents.length === 0){
                setOtherDocumentsData(initialSalesInvoiceData);
                return;
            }
            const data_Other = response.data.documents;
            data_Other.forEach((data: any) => {
                if(data.status === "Uploaded"){
                    setOtherDocumentsData((prev) => {
                        return {
                            ...prev,
                            pending : prev.pending + 1
                        }
                    });
                }else if(data.status === "Review"){
                    setOtherDocumentsData((prev) => {
                        return {
                            ...prev,
                            processing : prev.processing + 1
                        }
                    });
                }else if(data.status === "Data Entered"){
                    setOtherDocumentsData((prev) => {
                        return {
                            ...prev,
                            processed : prev.processed + 1
                        }
                    });
                }else if(data.status === "Exported"){
                    setOtherDocumentsData((prev) => {
                        return {
                            ...prev,
                            approved : prev.approved + 1
                        }
                    });
                }
            });
        }
    }

    useEffect(() => {
        // console.log(business?.id);
        fetchSalesInvoiceData();
        fetchPurchaseInvoiceData();
        fetchOtherDocumentsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[business]);
    
    return (
        <Stack spacing={4} w={'full'} justify={'center'} align={'center'}>
            <Stack
                direction={'row'}
                flexWrap={'wrap'}
                w={'95%'}
                justify={'space-between'}
            >
                <SalesInvoicesChart text={'Sales Invoice'} icon={HiDocumentReport} data={salesInvoiceData} />
                <SalesInvoicesChart text={'Purchase Invoice'} icon={RiDraftFill} data={purchaseInvoiceData} />
                <SalesInvoicesChart text={'Other Documents'} icon={HiDocument}  data={OtherDocumentsData} />
                {/* <SalesInvoicesChart text={'Bank Statements'} icon={RiBankFill} /> */}
            </Stack>
            <Stack
                direction={'row'}
                w={'95%'}
                justify={'center'}
                align={'center'}
                spacing={4}
                h={'xs'}
            >
                <Stack
                    p={3}
                    h={'xs'}
                    w={'59%'}
                    bg={'white'}
                    align={'center'}
                    boxShadow={'base'}
                    rounded={'md'}
                    spacing={3}
                >
                    <Stack direction={'row'} w={'full'} justify={'space-between'} align={"center"}>
                        <Heading fontSize={'2xl'} textAlign={'center'}>Expenses</Heading>
                        {/* <Select w={'80px'}>
                            <option selected value='2022'>2022</option>
                            <option value='2021'>2021</option>
                            <option value='2020'>2020</option>
                            <option value='2019'>2019</option>
                            <option value='2018'>2018</option>
                        </Select> */}
                    </Stack>

                    <ResponsiveContainer width={'100%'} height={'100%'}>
                        <BarChart data={data}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Bar dataKey="expenses" fill="rgba(5, 68, 94, 1)" />
                        </BarChart>
                    </ResponsiveContainer>
                </Stack>
                <Stack
                    p={3}
                    h={'xs'}
                    w={'40%'}
                    pb={'15px'}
                    bg={'white'}
                    justify={'center'}
                    align={'center'}
                    boxShadow={'base'}
                    rounded={'md'}
                    spacing={3}
                >
                    <Stack direction={'row'} w={'full'} justify={'space-between'} align={"center"}>
                        <Heading fontSize={'2xl'} textAlign={'center'}>Sales</Heading>
                        {/* <Select w={'80px'}>
                            <option selected value='2022'>2022</option>
                            <option value='2021'>2021</option>
                            <option value='2020'>2020</option>
                            <option value='2019'>2019</option>
                            <option value='2018'>2018</option>
                        </Select> */}
                    </Stack>
                    <ResponsiveContainer width={'100%'} height={'100%'}>
                        <AreaChart width={730} height={250} data={data2}
                            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                            <defs>
                                <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%" stopColor="rgba(5, 68, 94, 1)" stopOpacity={0.8} />
                                    <stop offset="95%" stopColor="rgba(5, 68, 94, 1)" stopOpacity={0} />
                                </linearGradient>
                            </defs>
                            <XAxis dataKey="name" />
                            <YAxis />
                            <CartesianGrid strokeDasharray="3 3" />
                            <Tooltip />
                            <Area type="monotone" dataKey="sales" stroke="rgba(5, 68, 94, 1)" fillOpacity={1} fill="url(#colorUv)" />
                        </AreaChart>
                    </ResponsiveContainer>
                </Stack>
            </Stack>
            {/* <Stack
                p={3}
                w={'95%'}
                bg={'white'}
                boxShadow={'base'}
                rounded={'md'}
                spacing={3}
            >
                <Heading fontSize={'2xl'}>Bookkeeping Information</Heading>
                <Stack
                    w={'full'}
                    direction={'row'}
                    spacing={72}
                >
                    <Stack>
                        <Text>Document Inbox: rbtesthamzabro@app.receipt-bot.com</Text>
                        <Text>Base Currency: Great Britain Pound</Text>
                        <Text>Last Document Upload Date: 12/02/2022</Text>
                    </Stack>
                    <Stack>
                        <Text>Accounting Software: Excel</Text>
                        <Text>Integration Status: Active</Text>
                        <Text>VAT/GST Status: Registered</Text>
                    </Stack>
                </Stack>
            </Stack> */}
        </Stack>
    );
}